import { render, staticRenderFns } from "./AppElementsLayout.vue?vue&type=template&id=1de208f4"
import script from "./AppElementsLayout.vue?vue&type=script&lang=js"
export * from "./AppElementsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports